import React, { useState } from "react";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import { format } from "date-fns";
import { Col } from "react-bootstrap";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Ageing({ setSlotSize, slotSize }) {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { PayAgingdata } = useSelector((state) => state.ReceivablePaybleSlice);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const [inputSlotSize, setInputSlotSize] = useState(slotSize || "");
  const { theme } = useTheme();
  const isdark = theme;
  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const generateAgeingRanges = (size) => {
    const s = parseInt(size);
    const ranges = [];

    for (let i = 0; i < 5; i++) {
      const from = i * s + 1;
      const to = (i + 1) * s;
      ranges.push(`${from === 1 ? 0 : from} To ${to} Days`);
    }

    ranges.push(`Above ${5 * s} Days`);
    return ranges;
  };

  // 🔹 Ranges sirf slotSize ke hisaab se banenge
  const ranges =
    slotSize && !isNaN(slotSize)
      ? generateAgeingRanges(slotSize).reverse()
      : [];
  const formatDateToDMY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const getRows =
    PayAgingdata?.OutstandingData?.map((row, index, arr) => {
      const totalLength = arr.length.toString().length;
      const rowObj = {
        id: index,
        chart: true,
        // srNumber: (index + 1).toString().padStart(totalLength, "0"),
        GroupMStName: row.GroupMStName,
        VouDate: formatDateToDMY(row.VouDate),
        AgingDays: row.AgingDays,
        Balance: formatIndianRupee(row.Balance),
      };
      ranges.forEach((range) => {
        rowObj[range] = row[range];
      });
      return rowObj;
    }) || [];

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "GroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Net Balance", key: "Balance", align: "right", format: "true" },
    ...ranges.map((range) => ({
      label: range,
      key: range,
      align: "right",
      format: "true",
    })),
  ];

  const getRows2 =
    PayAgingdata?.AcWiseAcDtl?.map((row, index, arr) => {
      const totalLength = arr.length.toString().length;
      const rowObj = {
        id: index,
        chart: true,
        // srNumber: (index + 1).toString().padStart(totalLength, "0"),
        AcName: row.AcName,
        AgingDays: row.AgingDays,
        Balance: formatIndianRupee(row.Balance),
      };
      ranges.forEach((range) => {
        rowObj[range] = row[range];
      });
      return rowObj;
    }) || [];

  const getColumns2 = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Net Balance", key: "Balance", format: "true" },
    ...ranges.map((range) => ({
      label: range,
      key: range,
      align: "right",
      format: "true",
    })),
  ];
  const handleSubmit = () => {
    if (inputSlotSize.trim() !== "" && !isNaN(inputSlotSize)) {
      setSlotSize(inputSlotSize);
    } else {
      alert("Please enter a valid slot size.");
    }
  };

  if (PayAgingdata === "no" || PayAgingdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          marginBottom: "16px",
          maxWidth: "300px",
        }}
      >
        {/* Label */}
        <div
          style={{
            fontSize: "11px",
            fontWeight: "600",
            color: isdark === "light" ? "#7c7c7c" : iscolourDark?.Colour12 || "#ffffff",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.4px",
          }}
        >
          ⏺ AGEING INTERVAL (DAYS)
        </div>

        {/* Input + Button Box */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
            border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10
              }`,
            borderRadius: "10px",
            overflow: "hidden",
            padding: "4px",
            minHeight: "48px",
          }}
        >
          <input
            type="number"
            placeholder="15"
            value={inputSlotSize}
            onChange={(e) => setInputSlotSize(e.target.value)}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              background: "transparent",
              padding: "8px 10px",
              fontSize: "14px",
              color: isdark === "light" ? "#000" : "#fff",
            }}
          />

          <button
            onClick={handleSubmit}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.03)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
            style={{
              border: "none",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease",
              transform: "scale(1)",
              background:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
            }}
          >
            Submit
          </button>
        </div>
      </div>
      {/* FIRST TABLE */}
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            AGEING - SET 1
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>

      {/* SECOND TABLE */}
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            AGEING - SET 2
          </h2>
        </div>

        <FASTable columns={getColumns2} data={getRows2} />
      </div>
    </div>
  );
}
